import {
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';
import {
  compareValues,
  SortDirection,
  toggleSortDirection,
} from '../../../lib/utils/sort';
import { ExamCenterService } from '../../../services';
import { ExamCenter } from '../../../types';

@Component({
  selector: 'app-exam-center-table',
  templateUrl: './exam-center-table.component.html',
  styleUrls: ['./exam-center-table.component.scss'],
})
export class ExamCenterTableComponent implements OnInit {
  @HostBinding('class.entity-table-component')
  hostClass = true;

  sortColumn: keyof ExamCenter = 'name';
  sortDirection: SortDirection = 'asc';

  constructor(public service: ExamCenterService) {}

  ngOnInit(): void {
    // Initiale Sortierung aus Service-Filter übernehmen
    this.sortColumn = this.service.listState.filter
      .sort as keyof ExamCenter;
    this.sortDirection =
      this.service.listState.filter.direction;

    // Daten laden
    this.service.loadList();
  }

  get items(): ExamCenter[] {
    const sorted = [
      ...this.service.listState.response.items,
    ];
    return this.sortArray(sorted);
  }

  sortBy(column: keyof ExamCenter) {
    const next = toggleSortDirection(
      this.sortColumn,
      column,
      this.sortDirection
    );
    this.sortColumn = next.column;
    this.sortDirection = next.direction;

    this.service.listState.filter.sort = this.sortColumn;
    this.service.listState.filter.direction =
      this.sortDirection;

    this.service.loadList();
  }

  private sortArray(array: ExamCenter[]): ExamCenter[] {
    return array.sort((a, b) => {
      const aVal = a[this.sortColumn] ?? '';
      const bVal = b[this.sortColumn] ?? '';
      return compareValues(aVal, bVal, this.sortDirection);
    });
  }
}
